import React, { useState, useEffect } from 'react';
import { IconFont } from '@src/features/common';
import './SFCLinkManage.less';

type Props = ISFCLinkManageProps;

export interface ISFCLinkManageProps {
  rootId: string;
  readOnly?: boolean;
}

export function SFCLinkManage(props: Props) {
  const { readOnly } = props;
  const [manageVisiable, setManageVisiable] = useState(false);
  const [virtualWidth, setVirtualWidth] = useState(0);
  const [virtualHeight, setVirtualHeight] = useState(0);
  const [mamangeTop, setMamangeTop] = useState(0);
  const [mamangeLeft, setmMamangeLeft] = useState(0);
  const [currentLink, setCurrentLink] = useState<HTMLAnchorElement>(document.createElement('a'));
  const [iptVal, setIptVal] = useState('');
  const editDom = document.getElementById(props.rootId);

  const hideManage = () => {
    setManageVisiable(false);
  };

  const showManage = (target: HTMLElement) => {
    const { width, height, top, left } = target.getBoundingClientRect();
    setManageVisiable(true);
    setVirtualWidth(width);
    setVirtualHeight(height);
    setMamangeTop(top);
    setmMamangeLeft(left);
    setIptVal(target.getAttribute('href') || '');
  };

  useEffect(() => {
    const editOver = (event: MouseEvent) => {
      const target = event.target as HTMLAnchorElement | null;

      if (target && target.tagName === 'A' && !readOnly) {
        showManage(target);
        setCurrentLink(target);
      }
    };
    editDom && editDom.addEventListener('mouseover', editOver);
    return () => {
      editDom && editDom.removeEventListener('mouseover', editOver);
    };
  }, [editDom, readOnly]);

  const removeLink = () => {
    const nodeList = Array.from(currentLink.childNodes) as Node[];
    currentLink.replaceWith(...nodeList);

    setManageVisiable(false);
  };

  const setLink = () => {
    if (iptVal) {
      currentLink.setAttribute('href', iptVal);
      hideManage();
    }
  };

  const toTarget = () => {
    let linkUrl = currentLink.getAttribute('href') || '';
    const protocolReg = /^http:\/\/|^https:\/\/|^\/\//;

    if (!protocolReg.test(linkUrl)) {
      linkUrl = '//' + linkUrl;
    }

    linkUrl && window.open(linkUrl);
  };

  const linkAct = () => {
    currentLink.style.textDecoration = 'underline';
  };

  const linkUnAct = () => {
    currentLink.style.textDecoration = 'none';
  };

  const iptChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;

    setIptVal(val);
  };

  const triggerSetLink = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      setLink();
    }
  };

  return (
    <section
      style={{
        visibility: manageVisiable ? 'visible' : 'hidden',
        top: mamangeTop + 'px',
        left: mamangeLeft + 'px',
        width: virtualWidth + 'px'
      }}
      className="link-mamange"
      onMouseLeave={hideManage}
    >
      <div
        className="link-virtual-con"
        style={{ width: virtualWidth + 'px', height: virtualHeight + 'px' }}
        onClick={toTarget}
        onMouseEnter={linkAct}
        onMouseLeave={linkUnAct}
      />
      <section className="manage-con">
        <IconFont type="icon-e-link-pre" className="tool-bar__link-con__icon" />
        <input
          type="text"
          className="manage-con__ipt"
          value={iptVal}
          onChange={iptChange}
          onKeyUp={triggerSetLink}
        />
        <IconFont type="icon-sure" className="manage-con__icon" onClick={setLink} />
        <IconFont type="icon-close" className="manage-con__icon" onClick={removeLink} />
      </section>
    </section>
  );
}

export default SFCLinkManage;
